import { IoClose } from "react-icons/io5";

const ConfirmActionModal = ({
  open,
  title,
  message,
  confirmText = "CONFIRM",
  cancelText = "CANCEL",
  onConfirm,
  onClose,
}) => {
  if (!open) return null;

  return (
    <div className="admin-modal-overlay">
      <div className="admin-modal">

        <div className="admin-modal-header">
          <div className="admin-modal-title">{title}</div>
          <button className="admin-modal-close" onClick={onClose}>
            <IoClose />
          </button>
        </div>

        <div className="admin-form-body">
          <p style={{ fontSize: "18px", color: "#333" }}>
            {message}
          </p>
        </div>

        <div className="admin-form-footer">
          <button className="admin-btn-cancel" onClick={onClose}>
            {cancelText}
          </button>
          <button className="admin-btn-save" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>

      </div>
    </div>
  );
};

export default ConfirmActionModal;